import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { useTheme } from 'modules/styles'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'

const messages = defineMessages({
  heading: {
    id: 'CheckExerciseFormSlug.HowToPerform.heading',
    defaultMessage: 'Don\'t know how to perform {exerciseName}?'
  },
  description: {
    id: 'CheckExerciseFormSlug.HowToPerform.description',
    defaultMessage: 'Our AI-powered form checker helps you master proper {exerciseName} technique. Upload your workout video and receive instant feedback on your form, including detailed analysis of your posture, movement tempo, and overall execution.'
  }
})

export function HowToPerform ({ exerciseName, content }) {
  const intl = useIntl()
  const theme = useTheme()

  // Use database content if available, otherwise fallback to template
  const hasContent = !!content
  const heading = hasContent
    ? `Common ${exerciseName} Form Mistakes`
    : formatMessageIntlUtil(intl, messages.heading, { exerciseName })

  console.log('[HowToPerform] exerciseName:', exerciseName)
  console.log('[HowToPerform] hasContent:', hasContent)
  console.log('[HowToPerform] content:', content)

  return (
    <Block bgc='white'>
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View mb={2}>
          <TextTitleCompressedHeavy style={{ textAlign: 'center' }}>
            {heading}
          </TextTitleCompressedHeavy>
        </View>

        <View>
          {hasContent
            ? (
              <div
                style={{ color: theme.colors.paragraph }}
                dangerouslySetInnerHTML={{
                  __html: markdownToHtmlStringUtil(content)
                }}
              />
              )
            : (
              <TextBodySmaller
                style={{
                  color: theme.colors.paragraph,
                  textAlign: 'center'
                }}
              >
                {formatMessageIntlUtil(intl, messages.description, { exerciseName })}
              </TextBodySmaller>
              )}
        </View>
      </View>
    </Block>
  )
}

HowToPerform.propTypes = {
  exerciseName: PropTypes.string.isRequired,
  content: PropTypes.string
}
